(function () {
  if (window.__ucCartNoticeReady) return;
  window.__ucCartNoticeReady = true;

  var hideTimer = null;

  function noticeText(html) {
    if (!html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = String(html);
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function getLineAnchor(line) {
    if (!line) return null;
    if (!window.matchMedia('(min-width: 750px)').matches) return null;

    var ids = ['CartItem-notice-actions-' + line, 'CartDrawer-Item-notice-actions-' + line];

    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) return el;
    }

    return null;
  }

  function hideNotice(el) {
    if (!el || !el.isConnected) return;
    el.classList.remove('is-visible');
    window.setTimeout(function () {
      el.remove();
    }, 350);
  }

  function clearNotices() {
    if (hideTimer) {
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }

    document.querySelectorAll('.uc-cart-item-notice').forEach(function (anchor) {
      anchor.replaceChildren();
    });

    document.querySelectorAll('.uc-cart-notice--floating').forEach(function (notice) {
      hideNotice(notice);
    });
  }

  function isGenericCartUpdateError(text) {
    var normalized = String(text || '').toLowerCase();
    return (
      /error while updating your cart/i.test(normalized) ||
      /updating your cart.*try again/i.test(normalized)
    );
  }

  window.__ucShowCartNotice = function (text, options) {
    // Product PDP only: never show this toast (cart / drawer pages still can)
    if (
      document.body.classList.contains('template-product') ||
      /^\/products\//.test(window.location.pathname || '')
    ) {
      return;
    }

    var message = noticeText(text);
    if (!message || isGenericCartUpdateError(message)) return;
    options = options || {};

    clearNotices();

    var anchor = getLineAnchor(options.line);
    var isItemNotice = Boolean(anchor);
    var el = document.createElement('div');
    el.className = 'uc-cart-notice' + (isItemNotice ? ' uc-cart-notice--item' : ' uc-cart-notice--floating');
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'assertive');
    el.innerHTML =
      '<div class="uc-cart-notice__inner">' +
      '<span class="uc-cart-notice__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M12 8v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '<circle cx="12" cy="16" r="0.75" fill="currentColor"/>' +
      '</svg></span>' +
      '<div class="uc-cart-notice__copy">' +
      (options.eyebrow ? '<p class="uc-cart-notice__eyebrow"></p>' : '') +
      '<p class="uc-cart-notice__text"></p>' +
      '</div>' +
      '</div>';

    if (options.eyebrow) {
      el.querySelector('.uc-cart-notice__eyebrow').textContent = options.eyebrow;
    }
    el.querySelector('.uc-cart-notice__text').textContent = message;

    if (isItemNotice) {
      anchor.appendChild(el);
    } else {
      document.body.appendChild(el);
    }

    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    hideTimer = window.setTimeout(
      function () {
        hideNotice(el);
        hideTimer = null;
      },
      options.duration || 4500
    );
  };
})();
